import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import {
  NDA,
  NDATemplatesErrorResponse,
} from "src/types/nda";
import {
  FETCH_NDA_TEMPLATES_REQUEST,
  FETCHING_NDA_TEMPLATES_FAILED,
  FETCHING_NDA_TEMPLATES_SUCCEEDED,
} from "./actionTypes";
import { call, put, takeEvery } from "redux-saga/effects";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const NDA_BASE_URL = `${apiUrl}/api/2.0/nda-templates`;

export const fetchNDARequest = createAction(FETCH_NDA_TEMPLATES_REQUEST);
export const fetchNDASucceeded = createAction<NDA[]>(
  FETCHING_NDA_TEMPLATES_SUCCEEDED,
);
export const fetchNDAFailed = createAction<NDATemplatesErrorResponse>(
  FETCHING_NDA_TEMPLATES_FAILED,
);
const fetchNDASaga = function* (
  action: ReturnType<typeof fetchNDARequest>,
): any {
  const fetchNDAApi = async () => {
    return axios({
      method: "GET",
      url: NDA_BASE_URL,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchNDAApi);
    yield put(fetchNDASucceeded(response));
  } catch (error) {
    yield put(fetchNDAFailed({ error: error }));
  }
};

export default function* ndaSaga() {
    yield takeEvery(FETCH_NDA_TEMPLATES_REQUEST, fetchNDASaga);
  }